import { combineReducers } from '@reduxjs/toolkit'

import fabrication  from './pcb_fabrication/fabricationSlice'
import smtStencil  from 'product_tabs/tab_smt_stencils/stencilSlice'
import assembly from 'product_tabs/tab_assembly/assemblySlice';
import bom from 'product_tabs/tab_parts/bomSlice';
import tab from 'product_tabs/tabs/tabSlice';
import alert from 'product_tabs/alerts/alertSlice';
import accessories from 'product_tabs/tab_accessories/accessoriesSlice';

const rootReducer = combineReducers({
  fabrication,
  smtStencil,
  assembly,
  bom,
  tab,
  alert,
  accessories,
});

export default rootReducer
